import { Injectable, inject } from '@angular/core'
import { Capacitor } from '@capacitor/core'
import { environment } from '../../../environments/environment'
// import { FacebookAnalytics } from '@shared/plugins/facebook-analytics.plugin'
import { CrashlyticsService } from './crashlithycs.service'
import { serializeForCrashlytics } from 'utils/CrashlyticsSerializer'
import { FacebookAnalytics } from '@capgo/capacitor-facebook-analytics'

@Injectable({
  providedIn: 'root',
})
export class MetaAnalyticsService {
  private readonly crashlyticsService = inject(CrashlyticsService)

  private initialized = false

  async initializeMetaAnalytics() {
    if (this.initialized || !Capacitor.isNativePlatform()) return

    try {
      if (environment.META_ADVERTISER_TRACKING_ENABLED) {
        await FacebookAnalytics.enableAdvertiserTracking()
      } else {
        await FacebookAnalytics.disableAdvertiserTracking()
      }

      await FacebookAnalytics.initAppEvents()

      const { status } = await FacebookAnalytics.getAdvertiserTrackingStatus()
      await this.crashlyticsService.log(`Meta advertiser tracking enabled: ${status}`)

      this.initialized = true
    } catch (error) {
      await this.crashlyticsService.recordException('metaAnalytics.initialize - error', [
        {
          key: 'error',
          value: serializeForCrashlytics(error),
          type: 'string',
        },
        {
          key: 'description',
          value: 'Error al inicializar Meta App Events',
          type: 'string',
        },
      ])
    }
  }
}
